import Vue from 'vue';
import Router from 'vue-router';
import VueGTag from 'vue-gtag';

import store from '../store';

import HomeRoutes from './home';
import CartRoutes from './cart';
import ReviewRoutes from './reviews';
import OrderRoutes from './order';
import CustomerRoutes from './customer';
import ProductDetails from '../pages/product/ProductDetails';

Vue.use(Router);

Vue.use(
  VueGTag,
  {
    config: { id: process.env.VUE_APP_GTAG_ID },
    appName: process.env.VUE_APP_GTAG_APP_NAME,
    pageTrackerScreenviewEnabled: true
  },
  router
);

const routes = [
  ...OrderRoutes,
  ...HomeRoutes,
  ...CartRoutes,
  ...CustomerRoutes,
  ...ReviewRoutes,
  {
    path: '/products/:productId/details',
    name: 'ProductDetails',
    component: ProductDetails
  }
];

const router = new Router({
  mode: 'history',
  routes: routes
});

router.beforeEach((to, from, next) => {
  const isInMaintenance = store.getters['application/isInMaintenance'];
  document.title = store.getters['application/getName'];

  if (isInMaintenance && to.name !== 'Maintenance') {
    next({ name: 'Maintenance' });
  } else {
    next();
  }
});

export default router;
